import AxiosInterceptor from "../utils/AxiosInterceptor";
// let BASE = "/admin";

const  tournamentsService = {
  getAll: (value) => AxiosInterceptor().post(`/tournaments`, value),
  changeStatus:(id)=>AxiosInterceptor().post(`/tournaments/${id.id}`,)
  
};
export default tournamentsService;
